import { format } from 'date-fns';

export const formatDate = (
  date: string | Date,
  dateFormat = 'yyyy-MM-dd HH:mm:ss',
): string => format(new Date(date), dateFormat);
